import { normalizeChildUpdatePayload } from '@utils/apiInputValidation';
import React, { Ref, forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { getDefaultDetails } from '@utils/childUtils';
import './childBeneficiaryEdit.css';
import './ChildComponent.css';
import BadgesComponent from '@components/common/Badges';
import CommonFormFields from '@pages/Forms/CommonFormFields';
import { beneficiaryPersonalDetails, childPersonalDetails } from '@constants/index';
import endpoints from '@config/endpoints';
import { useNavigate, useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { getData, postDataJSON, getDataWithCache, putDataJSON } from '../../../../services/CommonApiService';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';
import { updateForm } from '@store/actions/userManagementAction';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { imageData, isBeneficiaryModified, isImageEdited, setBeneficiaryDetails,setBenfId, setTsnID, updateDeliveryDetails } from '@store/actions/beneficiaryAction';
import axios from '@utils/axiosExt';
import Auth from '@utils/auth';
import { errorLogger } from '@utils/applicationLogUtils';
import Unauthorised from '@components/Auth/Unauthorised';
import { decodeWithKeyAndShift, encodeWithKeyAndShift } from '@utils/base64Utils';
import { buttonNames } from '@constants/appConstants';
import Button from '@components/common/Button';
import DetailRow from '@components/common/DetailRow';
import { updateChild, updateChildVerifyFromGrid } from '@store/actions/beneficiaryAction';
import { CHILD_ERRORS, CHILD_MIN_BIRTH_WEIGHT_GMS } from '../DeliveryOutcome/constants/DeliveryConstants';
import ChildKycModal from './ChildKycModal';
import { formatDateBasedOnTimeZone, isValidAlphabeticText } from '@utils/commonUtils';
import CreateAndVerifyModal from './CreateAndVerifyModal';
import beneficiaryReduxStoreRemovalUtils from '@utils/beneficiaryReduxStoreRemovalUtils';

export interface ChildComponentHandlerUpdateBeneficiary {
    handleUpdateSave: () => void;
}
interface childProps {
    currentChild: any;
    beneficiaryDetails: any;
    flow: string;
}

const ChildBeneficiaryEdit = forwardRef((props: childProps, ref: Ref<ChildComponentHandlerUpdateBeneficiary>) => {
    const userId = localStorage.getItem('userId');
    const { currentChild, beneficiaryDetails, flow } = props;
    const [genderOptions, setGenderOptions] = useState<any>([]);
    const [facilityDetails, setFacilityDetails] = useState<any>([]);
    const userDetail = JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userDetails')));
    const roleDetails=JSON.parse(decodeWithKeyAndShift(localStorage.getItem('userRoleDetails')));
    const [ufId, setUfId] = useState<string>('');
    const [facilityDetailsChanged, setFacilityDetailsChanged] = useState<boolean>(false);
    const navigate = useNavigate();
    const imageDetails = useSelector((state: RootState) => state.beneficiary.imageData);
    const isKYCLoading = useSelector((state: RootState) => state.beneficiary.isKYCLoading);
    const isImageModified = useSelector((state: RootState) => state.beneficiary.isImageEdited);
    const isKYCVerified = useSelector((state: RootState) => state.beneficiary.isKYCVerified);
    const childConsentIds = useSelector((state: RootState) => state.beneficiary.childConsentIds);
    const [beneficiaryPersonalDetailsData, setBeneficiaryPersonalDetailsData] = useState<any>(childPersonalDetails);
    const [beneficiaryServiceProviderData, setBeneficiaryServiceProviderData] = useState<any>({
        healthProviderName: {
            '#type': 'select',
            '#title': 'Health Provider Name',
            '#webform_key': 'healthProviderName',
            '#required': false,
            '#isDisabled': true,
            '#options': [],
        },
        mobiliserName: {
            '#type': 'select',
            '#title': 'Asha /Mobiliser Name',
            '#webform_key': 'mobiliserName',
            '#required': false,
            '#isDisabled': true,
            '#options': [],
        },
    })
    
    const [beneficiaryFacilityDetailsData, setBeneficiaryFacilityDetailsData] = useState<any>({
        facilityType: {
            '#type': 'select',
            '#title': 'Facility Type',
            '#isDisabled': true,
            '#webform_key': 'facilityType',
            '#required': true,
            '#options': [],
        },

        facilityName: {
            '#type': 'select',
            '#title': 'Facility Name',
            '#isDisabled': true,
            '#webform_key': 'facilityName',
            '#required': true,
            '#options': [],
        }
    })
    const [beneficiaryGuardianData, setBeneficiaryGuardianData] = useState<any>({});
    const [guardianDetailsForm, setGuardianDetailsForm] = useState<any>({});
    const [beneficiaryPersonalDetailsForm, setBeneficiaryPersonalDetailsForm] = useState<any>({
        name: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        motherName: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        motherAbhaId: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        number: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        dob: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        maturity: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        gender: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },
        weight: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        dateOfreg: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        timeOfreg: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        }
    })

    const [beneficiaryServiceProviderForm, setBeneficiaryServiceProviderFrom] = useState<any>({
        healthProviderName: {
            isError: false,
            message: '',
            isDisable: false,
            value: '',
        },

        mobiliserName: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
    })
    const [beneficiaryFacilityDetailsForm, setBeneficiaryFacilityDetailsForm] = useState<any>({

        facilityType: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
        facilityName: {
            isError: false,
            message: '',
            isDisable: true,
            value: '',
        },
    })
    const [showVerifyChildModal, setShowVerifyChildModal] = useState<boolean>(false);
    const [showChildModal, setShowChildModal] = useState<boolean>(false);
    const [isChildLogin, setIsChildLogin] = useState<boolean>(false);
    const [childParentId,setChildParentId] = useState<string>('')
    const [initialHealthProviderId, setInitialHealthProviderId] = useState<string>('')
    const [initialMobiliserId, setInitialMobiliserId] = useState<string>('')
    let isBenefHasFacilityData=false;
    let isBenefHasServiceData=false;
    let isBenefHasPoshanOrUwinData=false;
    let isParentHasFacilityAndServiceData = false;
    const [beneficiary, setBeneficiary] = useState<any>();
    const [showUnauthorized, setShowUnauthorized] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { id } = useParams()
    const userDetails = localStorage.getItem('userDetails');
    const decodedUserData = JSON.parse(decodeWithKeyAndShift(userDetails));
    useImperativeHandle(ref, () => ({
        handleUpdateSave() {
            handleSaveButton();
        }
    }));
    useEffect(() => {
        const fetchData = async () => {
            const response = await getData<any>(`${endpoints.childBeneficiaryById}/${id}`);
            setChildParentId(response?.data[0]?.parent_id);
            if (response.data.length === 0) {
                setShowUnauthorized(true);
            }
            else {
                setShowUnauthorized(false);
                setBeneficiary(response.data[0]);
                dispatch(setBeneficiaryDetails(response.data));
                dispatch(updateDeliveryDetails('parentAbha', response?.data[0]?.abha_id));
            }
        }
        fetchData();

        return () => {
            dispatch(updateChild('isKYCLoading', false));
        };
    }, []);
    const storeUserId = localStorage.getItem('userId');
    const childGenderOptions = localStorage.getItem('childGenderOptions');
    const childMaturityOptions = localStorage.getItem('childMaturityOptions');

    useEffect(() => {
        const fetchGenderOptions = async () => {
            let genderData : any= [];
            if (storeUserId && childGenderOptions) {
                genderData = JSON.parse(decodeWithKeyAndShift(childGenderOptions));
            } else {
                genderData = await getDataWithCache<any>(endpoints.getChildGender);
                localStorage.setItem('childGenderOptions', encodeWithKeyAndShift(JSON.stringify(genderData)));
            }
            const genderOptionsData = genderData?.data[0]?.map((key: any) => ({
                    value: key.gender_name,
                    label: key.gender_name,
                    id: key.gender_id,
                    code: key.gender_code,
                })) || [];
            setGenderOptions(genderOptionsData);
            setBeneficiaryPersonalDetailsData((prevState: any) => ({
                ...prevState,
                gender: {
                    ...prevState.gender,
                    '#options': genderOptionsData,
                },
                name: {
                    ...prevState.name,
                    '#isDisabled': !!currentChild.bal_abha_id
                }
            }));
        };
        fetchGenderOptions();

        const fetchMaturityOptions = async () => {
            let maturityData : any= [];
            if(storeUserId && childMaturityOptions){
                const maturityOptions = localStorage.getItem('childMaturityOptions');
                maturityData = JSON.parse(decodeWithKeyAndShift(maturityOptions));
            }
            else {
                maturityData = await getDataWithCache<any[]>(endpoints.getMaturity);
                localStorage.setItem('childMaturityOptions', encodeWithKeyAndShift(JSON.stringify(maturityData)));
            }
                const maturityOptionsData = maturityData?.data?.map((key: any) => ({
                    value: key.maturity_name,
                    label: key.maturity_name,
                    id: key.maturity_id,
                    code: key.maturity_code,
                }));
                
            setBeneficiaryPersonalDetailsData((prevState: any) => ({
                ...prevState,
                maturity: {
                    ...prevState.maturity,
                    '#options': maturityOptionsData,
                },
            }));
        };
        fetchMaturityOptions();
    }, []);

    const fetchMobiliserOptions = (facilityId: string, healthProviderId: string) => {
        if (healthProviderId && facilityId) {
            getData<any>(`${endpoints.getMobilizerTaggedByUserAndFacilityId}/${healthProviderId}/${facilityId}`).then((response) => {
                const mobiliserOptions = response?.data?.map((key: any) => ({
                    value: `${key.f_name || ''}${key.l_name ? ' ' + key.l_name : ''}`.trim(),
                    label: `${key.f_name || ''}${key.l_name ? ' ' + key.l_name : ''}`.trim(),
                    id: key.mobiliser_id
                }));
                setBeneficiaryServiceProviderData((prevState: any) => ({
                    ...prevState,
                    mobiliserName: {
                        ...prevState.mobiliserName,
                        '#options': mobiliserOptions,
                        '#isDisabled': false,
                    }
                }));
            });
        }
    };

    useEffect(() => {
        if (beneficiary) {
            const dynamicPersonalDetailsData = { ...beneficiaryPersonalDetailsData };
            let dynamicPersonalDetailsForm = { ...beneficiaryPersonalDetailsForm };
            const parentLabel = beneficiary?.relationship_name;
            const parentAbhaLabel = `${parentLabel}'s ABHA ID`;
            const parentNameLabel = `${parentLabel}'s Name`;
            const parentMobileLabel = `${parentLabel}'s Mobile Number`;

            dynamicPersonalDetailsData.motherAbhaId = {
                ...dynamicPersonalDetailsData.motherAbhaId,
                '#title': parentAbhaLabel
            };
            dynamicPersonalDetailsData.motherName = {
                ...dynamicPersonalDetailsData.motherName,
                '#title': parentNameLabel
            };
            dynamicPersonalDetailsData.number = {
                ...dynamicPersonalDetailsData.number,
                '#title': parentMobileLabel
            };
            dynamicPersonalDetailsData.name = {
                ...dynamicPersonalDetailsData.name,
                '#isDisabled': !!currentChild.bal_abha_id
            };

            dynamicPersonalDetailsForm = {
                ...dynamicPersonalDetailsForm,
                name: {
                    ...dynamicPersonalDetailsForm.name,
                    value: beneficiary?.benf_name || ''
                },
                motherAbhaId: {
                    ...dynamicPersonalDetailsForm.motherAbhaId,
                    value: beneficiary?.parent_abha_id || ''
                },
                motherName: {
                    ...dynamicPersonalDetailsForm.motherName,
                    value: beneficiary?.parent_name || ''
                },
                number: {
                    ...dynamicPersonalDetailsForm.number,
                    value: beneficiary?.parent_mob || ''
                },
                dob: {
                    ...dynamicPersonalDetailsForm.dob,
                    value: dayjs(beneficiary?.dob) || ''
                },
                maturity: {
                    ...dynamicPersonalDetailsForm.maturity,
                    value: beneficiary.maturity_status_name || '',
                    id: beneficiary.maturity_status_id || '',
                },
                weight: {
                    ...dynamicPersonalDetailsForm.weight,
                    value: beneficiary?.weight_at_birth_in_gm || '',
                },
                dateOfreg: {
                    ...dynamicPersonalDetailsForm.dateOfreg,
                    value: beneficiary?.registration_date || '',
                },
                timeOfreg: {
                    ...dynamicPersonalDetailsForm.timeOfreg,
                    value: beneficiary?.registration_date || '',
                },
                gender: {
                    ...dynamicPersonalDetailsForm.gender,
                    value: beneficiary.gender_name || '',
                    id: beneficiary.gender_id || '',
                },
            };
            setBeneficiaryPersonalDetailsData(dynamicPersonalDetailsData);
            setBeneficiaryPersonalDetailsForm(dynamicPersonalDetailsForm);
            setBeneficiaryServiceProviderFrom((prevState: any) => ({
                ...prevState,
                healthProviderName: {
                    ...prevState.healthProviderName,
                    value: beneficiary?.health_provider_name ? beneficiary?.health_provider_name[0] : '',
                    id: beneficiary.healthprovider_id ? beneficiary.healthprovider_id[0] : '    '
                },
                mobiliserName: {
                    ...prevState.mobiliserName,
                    value: beneficiary?.mobiliser_f_name ? beneficiary?.mobiliser_f_name?.[0] : '',
                    id: beneficiary?.mobiliser_id ? beneficiary?.mobiliser_id[0] : ''
                },
            }))
            if (Array.isArray(beneficiary?.guardian_details) && beneficiary?.guardian_details.length > 0) {
                const guardianData: any = {};
                const guardianForm: any = {};
                beneficiary?.guardian_details.forEach((g: any, idx: number) => {
                    const relType = g.relationship_type;
                    const nameKey = `${relType}_name`;
                    const mobKey = `${relType}_mobile`;
                    guardianData[nameKey] = {
                        '#type': 'textfield',
                        '#title': `${relType}'s Name`,
                        '#webform_key': nameKey,
                        '#required': true,
                        '#isDisabled': true,
                        '#options': [],
                    };
                    guardianData[mobKey] = {
                        '#type': 'textfield',
                        '#title': `${relType}'s Mobile Number`,
                        '#webform_key': mobKey,
                        '#required': false,
                        '#isDisabled': true,
                        '#options': [],
                    };
                    guardianForm[nameKey] = {
                        isError: false,
                        message: '',
                        value: g.guardian_name || ''
                    };
                    guardianForm[mobKey] = {
                        isError: false,
                        message: '',
                        value: g.guardian_mob || ''
                    };
                });
                setBeneficiaryGuardianData(guardianData);
                setGuardianDetailsForm(guardianForm);
            } else {
                const parentGender = beneficiary?.parent_gender_name;
                const relationshipName = beneficiary?.relationship_name;
                const isMotherAlive = beneficiary?.is_mother_alive;
                const defaultDetails = getDefaultDetails(parentGender, relationshipName, isMotherAlive);
                const defaultData: any = {};
                const defaultForm: any = {};
                defaultDetails.forEach((item: any, idx: number) => {
                    const key = item.label.replace(/[^a-zA-Z0-9]/g, '_');
                    defaultData[key] = {
                        '#type': 'textfield',
                        '#title': item.label,
                        '#webform_key': key,
                        '#required': false,
                        '#isDisabled': true,
                        '#options': [],
                    };
                    defaultForm[key] = {
                        isError: false,
                        message: '',
                        value: item.value || '',
                    };
                });
                setBeneficiaryGuardianData(defaultData);
                setGuardianDetailsForm(defaultForm);
            }
            setInitialHealthProviderId(beneficiary?.healthprovider_id ? beneficiary?.healthprovider_id[0] : '');
            setInitialMobiliserId(beneficiary?.mobiliser_id ? beneficiary?.mobiliser_id[0] : '');
            setBeneficiaryFacilityDetailsForm((prevState: any) => ({
                ...prevState,
                facilityType: {
                    ...prevState.facilityType,
                    value: beneficiary?.facility_type,
                    id: beneficiary?.facility_type_id ? beneficiary?.facility_type_id[0] : ''
                },
                facilityName: {
                    ...prevState.facilityName,
                    value: beneficiary?.facility_name,
                    id: beneficiary?.facility_id ? beneficiary?.facility_id[0] : ''
                },                
            }))
            isBenefHasServiceData=beneficiary?.healthprovider_id?.length>0 ? true : false;
            isBenefHasFacilityData=beneficiary?.facility_id?.length>0 ? true : false;
            isBenefHasPoshanOrUwinData=beneficiary?.source_name === 'poshan' || beneficiary?.source_name === 'uwin';
            isParentHasFacilityAndServiceData = beneficiary?.parent_healthprovider_id?.length > 0 && beneficiary?.parent_facility_id?.length > 0;

            if (!isBenefHasFacilityData && !isBenefHasServiceData && isParentHasFacilityAndServiceData) {
                setBeneficiaryFacilityDetailsForm((prevState: any) => ({
                    ...prevState,
                    facilityType: {
                        ...prevState.facilityType,
                        value: beneficiary?.parent_facility_type?.[0] || '',
                        id: beneficiary?.parent_facility_type_id?.[0] || '',
                    },
                    facilityName: {
                        ...prevState.facilityName,
                        value: beneficiary?.parent_facility_name?.[0] || '',
                        id: beneficiary?.parent_facility_id?.[0] || '',
                    },
                }));

                setBeneficiaryServiceProviderFrom((prevState: any) => ({
                    ...prevState,
                    healthProviderName: {
                        ...prevState.healthProviderName,
                        value: beneficiary?.parent_health_provider_name?.[0] || '',
                        id: beneficiary?.parent_healthprovider_id?.[0] || '',
                        isDisable: true,
                    },
                    mobiliserName: {
                        ...prevState.mobiliserName,
                        value: beneficiary?.parent_mobiliser_name?.[0] || '',
                        id: beneficiary?.parent_mobiliser_id?.[0] || '',
                        isDisable: true,
                    },
                }));
                setBeneficiaryFacilityDetailsData((prevState: any) => ({
                    ...prevState,
                    facilityType: {
                        ...prevState.facilityType,
                        '#options': [{ value: beneficiary?.parent_facility_type?.[0] || '', label: beneficiary?.parent_facility_type?.[0] || '', id: beneficiary?.parent_facility_type_id?.[0] || '' }],
                        '#isDisabled': true,
                    },
                    facilityName: {
                        ...prevState.facilityName,
                        '#options': [{ value: beneficiary?.parent_facility_name?.[0] || '', label: beneficiary?.parent_facility_name?.[0] || '', id: beneficiary?.parent_facility_id?.[0] || '' }],
                        '#isDisabled': true,
                    },
                }));
                const formFacilityId = beneficiaryFacilityDetailsForm?.facilityName?.id || '';
                const formHealthProviderId = beneficiaryServiceProviderForm?.healthProviderName?.id || '';
                const facilityIdForMobiliser = formFacilityId || beneficiary?.parent_facility_id?.[0] || '';
                const healthProviderIdForMobiliser = formHealthProviderId || beneficiary?.parent_healthprovider_id?.[0] || '';
                fetchMobiliserOptions(facilityIdForMobiliser, healthProviderIdForMobiliser);
                if (userDetail.usertype_name === 'Field Level User') {
                    setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { mobiliserName: any }) => ({
                        ...beneficiary_facilitydetails,
                        ['mobiliserName']: {
                            ...beneficiary_facilitydetails['mobiliserName'],
                            '#isDisabled': true,
                        }
                    }));
                }
                else {
                    setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { mobiliserName: any }) => ({
                        ...beneficiary_facilitydetails,
                        ['mobiliserName']: {
                            ...beneficiary_facilitydetails['mobiliserName'],
                            '#isDisabled': false,
                        }
                    }));
                }
            } else if (!isBenefHasServiceData && isBenefHasPoshanOrUwinData ? true : !isBenefHasFacilityData) {
                fetchFacilityData();
            } else {
                setBeneficiaryFacilityDetailsData((prevState: any) => {
                    return {
                        ...prevState,
                        ['facilityName']: {
                            ...prevState['facilityName'],
                            '#isDisabled': true
                        },
                        ['facilityType']: {
                            ...prevState['facilityType'],
                            '#isDisabled': true,
                        }
                    }
                })
                if (userDetail.usertype_name === 'Field Level User') {
                    setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { mobiliserName: any }) => ({
                        ...beneficiary_facilitydetails,
                        ['mobiliserName']: {
                            ...beneficiary_facilitydetails['mobiliserName'],
                            '#isDisabled': true,
                        }
                    }));
                }
                else {
                    setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { mobiliserName: any }) => ({
                        ...beneficiary_facilitydetails,
                        ['mobiliserName']: {
                            ...beneficiary_facilitydetails['mobiliserName'],
                            '#isDisabled': false,
                        }
                    }));
                    const formFacilityId = beneficiaryFacilityDetailsForm?.facilityName?.id || '';
                    const formHealthProviderId = beneficiaryServiceProviderForm?.healthProviderName?.id || '';
                    const facilityIdForMobiliser = formFacilityId || beneficiary?.parent_facility_id?.[0] || decodedUserData?.facility_id || '';
                    const healthProviderIdForMobiliser = formHealthProviderId || beneficiary?.parent_healthprovider_id?.[0] || decodedUserData?.facility_type_id || '';
                    fetchMobiliserOptions(facilityIdForMobiliser, healthProviderIdForMobiliser);
                }
            }
            dispatch(setBenfId(beneficiary.benef_id));
        }
    }, [beneficiary])

    const fetchFacilityData = async () => {
        const facility_details_response = await getData<any>(`${endpoints.getLinkedFacilitiesByUserById}/${userId}`);
        setFacilityDetails(facility_details_response.data[0]);
        const parentFacility = facility_details_response.data[0].find((item: any) => item.is_parent === true);
        setBeneficiaryFacilityDetailsForm((prevState: any) => ({
          ...prevState,
          ['facilityName']: {
            ...prevState['facilityName'],
            value: parentFacility?.facility_name,
            id: parentFacility?.facility_id
          },
          ['facilityType']: {
            ...prevState['facilityType'],
            value: parentFacility?.facility_type_name,
            id: parentFacility?.facility_type_id
          }
  
        }))
        let facilityIdToGetProvider=parentFacility?.facility_id
        setBeneficiaryFacilityDetailsData((beneficiary_facilitydetails: { healthProviderName: any, facilityName: any, mobiliserName: any, ward: any, village: any }) => ({
          ...beneficiary_facilitydetails,
          facilityName: {
            ...beneficiary_facilitydetails.facilityName,
            '#options': facility_details_response.data[0]?.map((key: any) => ({
              value: key.facility_name,
              label: key.facility_name,
              id: key.facility_id
            })),
            '#isDisabled': facility_details_response.data[0]?.length=== 1 ? true : false
          }
        }));
  
        if (facility_details_response.data[0].length === 1) {
          facilityIdToGetProvider=facility_details_response.data[0][0].facility_id;
          setBeneficiaryFacilityDetailsForm((prevState: any) => ({
            ...prevState,
            ['facilityName']: {
              ...prevState['facilityName'],
              value: facility_details_response.data[0][0].facility_name,
              id: facility_details_response.data[0][0].facility_id
            },
            ['facilityType']: {
              ...prevState['facilityType'],
              value: facility_details_response.data[0][0].facility_type_name,
              id: facility_details_response.data[0][0].facility_type_id
            }
          }))
        }
        facilityIdToGetProvider?.trim() && fetchHealthProviderData(facilityIdToGetProvider);
        if(userDetail.usertype_name === 'Field Level User'){
          setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { mobiliserName: any }) => ({
              ...beneficiary_facilitydetails,
              ['mobiliserName']: {
                  ...beneficiary_facilitydetails['mobiliserName'],
                  '#isDisabled': true,
              }
          }));
      }
      else{
          setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { mobiliserName: any }) => ({
              ...beneficiary_facilitydetails,
              ['mobiliserName']: {
                  ...beneficiary_facilitydetails['mobiliserName'],
                  '#isDisabled': false,
              }
          }));
      }
      if(roleDetails?.includes('Administrator')){
       setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { healthProviderName: any }) => ({
              ...beneficiary_facilitydetails,
              ['healthProviderName']: {
                  ...beneficiary_facilitydetails['healthProviderName'],
                  '#isDisabled': false,
              }
          }));
      }
      else{
         setBeneficiaryServiceProviderData((beneficiary_facilitydetails: { healthProviderName: any }) => ({
              ...beneficiary_facilitydetails,
              ['healthProviderName']: {
                  ...beneficiary_facilitydetails['healthProviderName'],
                  '#isDisabled': true,
              }
          }));
      }
        const facilityTypes = facility_details_response?.data[0]?.map((key: any) => ({
          value: key.facility_type_name,
          label: key.facility_type_name,
          id: key.facility_type_id
        }));
        const filteredFacilityType = facilityTypes.filter((obj: any, index: any) => {
          return index === facilityTypes.findIndex((o: any) => obj.value === o.value);
        })
      setBeneficiaryFacilityDetailsData((prevState: any) => {
          return {
            ...prevState,
            ['facilityType']: {
              ...prevState['facilityType'],
              '#options': filteredFacilityType,
              '#isDisabled': facilityTypes?.length=== 1 ? true : false
            }
          }
        })
      }

    const handlePersonalDetailsFormChange = (value: any | boolean, key: string, id?: any, option?: any, code?: any) => {
        let newId = id;
        if (key === 'name' && (value.length > 50 || (value && !isValidAlphabeticText(value)))) {
            return;
          }

        if(key === 'weight') {
            if (!/^(\d+(\.\d*)?|\.\d*|)$/.test(value)) {
              return;
            } else if (value > 10000){
              return;
            }
          }
        if (Array.isArray(id) && value) {
            const found = id.find((opt: any) => opt.value === value || opt.label === value);
            newId = found?.id || '';
        } else if (option && option.id) {
            newId = option.id;
        } else if (typeof value === 'object' && value !== null && value.id) {
            newId = value.id;
        }
        setBeneficiaryPersonalDetailsForm((prevState: any) => ({
            ...prevState,
            [key]: {
                ...prevState[key],
                value,
                id: newId,
                code,
                isError: false,
                message: '',
            },
        }));
    }
   
    const handleServiceDetailsFormChange = (value: any, key: string, id: any, option: any, code: any,) => {
        if (value && key === 'healthProviderName') {
      setBeneficiaryServiceProviderFrom((prevState: any) => ({
        ...prevState,
        mobiliserName: {
          ...prevState.mobiliserName,
          value: '',
          id: '',
          isError: false,
          message: '',
        }
      }));
      const ufTaggedId = option.find((item: any) => item.id === id);
      setUfId(ufTaggedId.ufTaggedId)
    }
        setBeneficiaryServiceProviderFrom((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
    }
    const handleFacilityDetailsFormChange = (value: any, key: string, id: any, option: any, code: any,) => {
        setFacilityDetailsChanged(true);
          setBeneficiaryFacilityDetailsForm((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id: id,
        code: code,
        isError: false,
        message: '',
      },
    }));
    }
   
    useEffect(() => {
        if (isImageModified) {
            dispatch(isBeneficiaryModified(true))
        }
        else {
            dispatch(isBeneficiaryModified(false))
        }
    }, [beneficiaryPersonalDetailsForm, isImageModified
    ])

     useEffect(() => {
        if (facilityDetailsChanged && beneficiaryFacilityDetailsForm.facilityName.value !== '' && beneficiaryFacilityDetailsForm.facilityName.value !== undefined && beneficiaryFacilityDetailsForm.facilityName.value) {
           fetchHealthProviderData(beneficiaryFacilityDetailsForm.facilityName.id);
        }
      }, [beneficiaryFacilityDetailsForm.facilityName.value])
      useEffect(() => {
        if (!isBenefHasFacilityData && !isBenefHasServiceData && beneficiaryServiceProviderForm.healthProviderName.value !== '' && beneficiaryServiceProviderForm.healthProviderName.value !== undefined &&
          ufId !== '' && ufId !== undefined
        ) {
          fetchAshaData();
        }
      }, [ufId])

      const fetchAshaData = async () => {
        const AshaName = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(ufId)}`);
        const Ashaname = AshaName?.data.map((key: any) => ({
          value: key.f_name + " " + key.l_name,
          label: key.f_name + " " + key.l_name,
          id: key.mobiliser_id,
          code: key.user_code
        }));
        setBeneficiaryServiceProviderData((prevState: any) => {
          return {
            ...prevState,
            ['mobiliserName']: {
              ...prevState['mobiliserName'],
              '#options': Ashaname
            }
          }
        })
      }

    const fetchHealthProviderData = async (facilityId:string) => {
        const Health_provider = await getData<any>(`${endpoints.getHealthProviderTagged(facilityId)}`);
        const HealthProvider = Health_provider?.data?.map((key: any) => ({
          value: `${key.f_name} ${key.l_name}`,
          label: `${key.f_name} ${key.l_name}`,
          id: key.user_id,
          code: key.user_code,
          ufTaggedId: key.uf_tagged_id
        }));
        setBeneficiaryServiceProviderData((prevState: any) => {
          return {
            ...prevState,
            ['healthProviderName']: {
              ...prevState['healthProviderName'],
              '#options': HealthProvider,
              '#isDisabled': Health_provider?.data?.length === 1 ? true : false,
            }
          }
        })
    
        if (userDetail?.usertype_name === 'Facility Level User' || Health_provider?.data.length === 1) {
          const loggedInUserName=(userDetail?.first_name + ' ' + userDetail?.middle_name + ' ' + userDetail?.last_name);
          const healthProviderData = Health_provider?.data.find((item: any) => `${item.f_name} ${item.l_name}` === loggedInUserName.replace('null', '').replace('  ', ' '));
          if (healthProviderData) {
            setBeneficiaryServiceProviderFrom((prevState: any) => ({
              ...prevState,
              ['healthProviderName']: {
                ...prevState['healthProviderName'],
                value: healthProviderData?.f_name + ' ' + healthProviderData?.l_name,
                id: healthProviderData?.user_id
              }
            }))
            const AshaName = await getDataWithCache<any>(`${endpoints.getMobiliserTagged(healthProviderData.uf_tagged_id)}`);
            const Ashaname = AshaName?.data.map((key: any) => ({
              value: key.f_name + " " + key.l_name,
              label: key.f_name + " " + key.l_name,
              id: key.mobiliser_id,
              code: key.user_code
            }));
            setBeneficiaryServiceProviderData((prevState: any) => {
              return {
                ...prevState,
                ['mobiliserName']: {
                  ...prevState['mobiliserName'],
                  '#options': Ashaname,
                  '#isDisabled': false,
                }
              }
            })
          }
        }
      }
    const handleCreateClick = async () => {
        try {
            const childDetailsResponse = await getData<any>(`${endpoints.getChildBeneficiaries}/${childParentId}`);
            const response = await getData<any>(`${endpoints.getBeneficiaryById}/${childParentId}`);
            const childDobs = childDetailsResponse.data[0]?.map((item: any) => {
            return formatDateBasedOnTimeZone(item?.dob)
            });
            const childBalABHAIds = childDetailsResponse.data[0]?.map((item: any) => item.bal_abha_id);
            const reqData = {
            beneficiary: response.data[0],
            childDobs: childDobs,
            beneficiaryDetails: response.data[0],
            childData: beneficiary,
            childBalABHAIds: childBalABHAIds,
            childBenfId: currentChild?.benef_id
            };
            const encodedData = encodeWithKeyAndShift(JSON.stringify(reqData));
            dispatch(updateChild('verifyChildFromGridData', encodedData));
        } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
        }
        setShowVerifyChildModal(true);
        dispatch(updateChild("updateChildVerifyFromView", true));
        dispatch(updateChildVerifyFromGrid(true));
        dispatch(updateChild("parentAbha", currentChild?.parent_abha_id));

    }

    const handleSaveButton = async () => {
        let checkError = false
        if (!beneficiary?.benef_id) return;
        if (!beneficiaryPersonalDetailsForm.name.value?.trim()) {
            setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                ...prevState,
                name: { ...prevState.name, isError: true, message: CHILD_ERRORS.NAME },
            }));
            checkError = true;
        }
        if (!beneficiaryPersonalDetailsForm.gender.value || !beneficiaryPersonalDetailsForm.gender.id) {
            setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                ...prevState,
                gender: { ...prevState.gender, isError: true, message: CHILD_ERRORS.GENDER },
            }));
            checkError = true;
        }
        if (!beneficiary?.dob || !dayjs(beneficiary.dob).isValid() || dayjs(beneficiary.dob).isAfter(dayjs())) {
            setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                ...prevState,
                dob: { ...prevState.dob, isError: true, message: CHILD_ERRORS.DOB },
            }));
            checkError = true;
        }
        const birthWeight = beneficiaryPersonalDetailsForm.weight.value;
        const hasBirthWeight = birthWeight != null && String(birthWeight).trim() !== '';
        if (hasBirthWeight && (!Number.isSafeInteger(Number(birthWeight)) || Number(birthWeight) < CHILD_MIN_BIRTH_WEIGHT_GMS)) {
            setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                ...prevState,
                weight: {
                    ...prevState.weight,
                    isError: true,
                    message: CHILD_ERRORS.WEIGHT_IN_GMS,
                },
            }))
            checkError = true
        }
        if (!beneficiaryPersonalDetailsForm.maturity.value) {
            setBeneficiaryPersonalDetailsForm((prevState: any) => ({
                ...prevState,
                maturity: {
                    ...prevState.maturity,
                    isError: true,
                    message: CHILD_ERRORS.MATURITY,
                },
            }))
            checkError = true
        }
        if (!checkError) {
            const payload: any = {
                childBenfId: beneficiary.benef_id || null,
                childName: beneficiaryPersonalDetailsForm.name.value.trim(),
                abhaId: currentChild?.bal_abha_id || null,
                beneficiaryDob: new Date(new Date(beneficiary?.dob).setDate(new Date(beneficiary?.dob).getDate() + 1))
                    .toISOString().split('T')[0],
                genderId: beneficiaryPersonalDetailsForm.gender.id, weightAtBirth: beneficiaryPersonalDetailsForm.weight.value,
                maturityStatusId: beneficiaryPersonalDetailsForm.maturity.id,
                isMotherAlive: null,
                healthProviderId: beneficiaryServiceProviderForm.healthProviderName.id ? [beneficiaryServiceProviderForm.healthProviderName.id] : [],
                mobiliserId: beneficiaryServiceProviderForm.mobiliserName.id ? [beneficiaryServiceProviderForm.mobiliserName.id] : [],
                isMobiliseChanged: initialMobiliserId === beneficiaryServiceProviderForm.mobiliserName.id ? false : true,
                isHealthProviderChanged: initialHealthProviderId === beneficiaryServiceProviderForm.healthProviderName.id ? false : true,
                facilityId: beneficiaryFacilityDetailsForm?.facilityName.id,
                imageData: null,
                url: null,
                description: '',
                parentUserId: userId || null,
                consentTemplateDetails: childConsentIds ? childConsentIds?.map((item: any) => ({ consent_template_id: item })) : null,
                kycVerified: currentChild?.is_kyc_verified,
                processChannel: 'web'
            };
            try {
                const encodedPayload = encodeWithKeyAndShift(JSON.stringify(normalizeChildUpdatePayload(payload)))
                await putDataJSON<any>(`${endpoints.updateChild}`, { data: encodedPayload });
                dispatch(updateChild("childConsentIds", []));
                if (isImageModified) {
                    try {
                        if (imageDetails) {
                            if (imageDetails instanceof FormData) {
                                imageDetails.append("imageType", "beneficiary_profile");
                                imageDetails.append("objectId", beneficiary.benef_id);
                            }
                            await axios.post(`${endpoints.beneficiaryImageUpload}`, imageDetails, Auth.loggedInWithMultipart())
                        }
                    } catch (error: any) {
                        errorLogger(error?.response?.data || error?.response || error)
                    }
                }
                dispatch(updateForm("file", null));
                dispatch(isImageEdited(false));
                dispatch(isBeneficiaryModified(false));
                dispatch(imageData(''));
                navigate("/beneficiaries");
                beneficiaryReduxStoreRemovalUtils(dispatch);
                toast.success("Beneficiary updated successfully", {
                    position: "top-center"
                })
            }
            catch (error: any) {
                errorLogger(error?.response?.data || error?.response || error)
            }
        }

    }

    const handleKYCClick = () => {
        setShowChildModal(true);
        setIsChildLogin(true);
        dispatch(updateChild("childBalAbha", currentChild?.bal_abha_id));
    };

    const handleCloseKycModal = () => {
        setShowChildModal(false);
        setIsChildLogin(false);
    };
    
    return (<>
        {showUnauthorized ? <Unauthorised /> :
            <>
      {isKYCLoading && <span className="childViewloader"></span>}
            <div className="beneficiary_create">
                <div className="edit_beneficiary">
                    <BadgesComponent
                        className="over-badge"
                        badgeName="Personal Details"
                        variant="primary-1"
                        badgeType="case5"
                    />
                    <div className="edit_beneficiary">
                        <div className="edit_Child_beneficiary_page">
                            <form className="edit_container_page">
                                <CommonFormFields
                                    formData={{
                                        name: beneficiaryPersonalDetailsData.name || ''
                                    }}
                                    formState={{
                                        name: beneficiaryPersonalDetailsForm.name || ''
                                    }}
                                    handleFormChange={handlePersonalDetailsFormChange}
                                />

                                {currentChild?.bal_abha_id ? (
                                    <div>
                                    <DetailRow
                                        label={"BAAL ABHA ID"}
                                        value={currentChild.bal_abha_id}
                                    />
                                    {!isKYCVerified && <Button
                                        onClick={handleKYCClick}
                                        disabled={!currentChild?.bal_abha_id}
                                        id=""
                                        buttonName={buttonNames.ADD_KYC}
                                        colorType="primary-2"
                                        icon=""
                                        iconPosition=""
                                    />}
                                    </div>
                                ) : (
                                    <div key="childAbha" className="childAbha_wrapper">
                                        <div className="ip-with-label">
                                            <label className="label-name-required-for-ip">
                                                BAAL ABHA ID
                                            </label>
                                            <div className="create-button-clickable-button">
                                                <Button
                                                    onClick={handleCreateClick}
                                                    disabled={currentChild?.is_dead || !currentChild?.parent_abha_id || currentChild?.bal_abha_id}
                                                    id=""
                                                    buttonName={buttonNames.linkAbha}
                                                    colorType="primary"
                                                    icon=""
                                                    iconPosition=""
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <CommonFormFields
                                    formData={{
                                        motherName: beneficiaryPersonalDetailsData.motherName || ''
                                    }}
                                    formState={{
                                        motherName: beneficiaryPersonalDetailsForm.motherName || ''
                                    }}
                                    handleFormChange={handlePersonalDetailsFormChange}
                                />
                                {
                                    (() => {
                                        const { name, motherName, ...restData } = beneficiaryPersonalDetailsData;
                                        const { name: n, motherName: m, ...restForm } = beneficiaryPersonalDetailsForm;
                                        return (
                                            <CommonFormFields
                                                formData={restData}
                                                formState={restForm}
                                                handleFormChange={handlePersonalDetailsFormChange}
                                            />
                                        );
                                    })()
                                }
                            </form>
                        </div>
                    </div>
                </div>
                 <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                <div className="edit_beneficiary">
                    <BadgesComponent
                        className="over-badge"
                        badgeName="Father / Guardian Details"
                        variant="primary-1"
                        badgeType="case5"
                    />
                    <div className="edit_beneficiary">
                        <div className="edit_guardian_details">
                            <form className="edit_container_page">
                                <CommonFormFields
                                    formData={beneficiaryGuardianData}
                                    formState={guardianDetailsForm}
                                    handleFormChange={() => {}}
                                />
                            </form>
                        </div>
                    </div>
                </div>
                </div>
                <hr></hr>
                <div style={{ display: "flex", flexDirection: "row", gap: "20px" , width: "100%"}}>
                    <div className="edit_beneficiary">
                        <BadgesComponent
                            className="over-badge"
                            badgeName="Service Provider"
                            variant="primary-1"
                            badgeType="case5"
                        />
                        <div className="edit_beneficiary">
                            <div className="edit_service_provider">
                                <form className="edit_container_page">
                                    <CommonFormFields
                                        formData={beneficiaryServiceProviderData}
                                        formState={beneficiaryServiceProviderForm}
                                        handleFormChange={handleServiceDetailsFormChange}
                                    />
                                </form>
                            </div>
                        </div>
                    </div>
                    <span style={{ borderLeft: "1px solid #8080805e", height: "100px" }}></span>
                    <div className="edit_beneficiary">
                        <BadgesComponent
                            className="over-badge"
                            badgeName="Facility Details"
                            variant="primary-1"
                            badgeType="case5"
                        />
                        <div className="edit_beneficiary">
                            <div className="edit_facility_details">
                                <form className="edit_container_page" />
                                <div style={{ display: "flex", gap: "20px", width: "100%"}}>

                                    <CommonFormFields
                                        formData={{ facilityType: beneficiaryFacilityDetailsData.facilityType }}
                                        formState={{ facilityType: beneficiaryFacilityDetailsForm.facilityType }}
                                        handleFormChange={handleFacilityDetailsFormChange}
                                    />
                                    <CommonFormFields
                                        formData={{ facilityName: beneficiaryFacilityDetailsData.facilityName }}
                                        formState={{ facilityName: beneficiaryFacilityDetailsForm.facilityName }}
                                        handleFormChange={handleFacilityDetailsFormChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div></>}
                <CreateAndVerifyModal
      showModal={showVerifyChildModal}
      handleClose={() => setShowVerifyChildModal(false)}
    />
        <ChildKycModal currentChild={currentChild} flow={flow} showChildKycModal={showChildModal} isChildKycLogin={isChildLogin} onClose={handleCloseKycModal}/>    
    </>)
})
ChildBeneficiaryEdit.displayName = 'BeneficiaryEdit'
export default ChildBeneficiaryEdit;